module.exports = __webpack_public_path__ + "img/scotiabank.d77d68e.png";